module.exports = __webpack_public_path__ + "img/notifications-colored.9de00f1a.svg";